module.exports = __webpack_public_path__ + "img/59.b16079ab.png";